import React, { useEffect, useState } from 'react';
import './style.css';

export default function CompletionPage() {
  const [email, setEmail] = useState('');

  useEffect(() => {
    // Get user email from localStorage
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    if (currentUser.email) {
      setEmail(currentUser.email);
    }
  }, []);

  const handleDownloadApp = () => {
    // Save a flag indicating user should see their report in the app
    localStorage.setItem('assessmentCompleted', 'true');
    localStorage.setItem('assessmentEmail', email);
    
    // Redirect to App Store
    window.open('https://apps.apple.com/us/app/brilliance-buddy/id6752860908', '_blank');
  };

  return (
    <div className="completion-container">
      <div className="completion-wrap">
        <div className="completion-header">
          <h1 className="completion-title">
            Assessment <span className="highlight">Complete!</span>
          </h1>
          <div className="completion-checkmark">✓</div>
        </div>

        <div className="completion-content">
          <p className="completion-message">
            Congratulations! You've successfully completed the Native Brilliance Cognitive Assessment.
          </p>

          <div className="metrics-summary">
            <h2>Your Assessment Has Been Saved</h2>
            <p className="email-display">Results saved for: <strong>{email}</strong></p>
          </div>

          <div className="next-steps">
            <h2>View Your Personalized Native Brilliance Report</h2>
            <p>
              To see your complete Native Brilliance report with detailed insights about your 
              cognitive profile, download the Brilliance Buddy app.
            </p>

            <div className="app-features">
              <h3>In the Brilliance Buddy app, you'll get:</h3>
              <ul>
                <li>✓ Your complete Native Brilliance cognitive profile</li>
                <li>✓ Personalized insights about your cognitive strengths</li>
                <li>✓ Detailed breakdown of your NB metrics (F1, F2, F3, F4, M1-M4)</li>
                <li>✓ Your cognitive type identification</li>
                <li>✓ Restoration recommendations tailored to your profile</li>
                <li>✓ Chat support for understanding your results (Coming Soon)</li>
              </ul>
            </div>

            <div className="download-section">
              <button 
                className="download-btn primary"
                onClick={handleDownloadApp}
              >
                Download Brilliance Buddy App
              </button>
              
              <div className="app-links">
                <p className="coming-soon">Available on:</p>
                <div className="store-buttons">
                  <button 
                    className="store-btn" 
                    onClick={() => window.open('https://apps.apple.com/us/app/brilliance-buddy/id6752860908', '_blank')}
                  >
                    📱 iOS App Store
                  </button>
                  <button className="store-btn" disabled>
                    🤖 Google Play Store (Coming Soon)
                  </button>
                </div>
              </div>
            </div>

            <div className="instructions">
              <h3>How to View Your Report:</h3>
              <ol>
                <li>Download the Brilliance Buddy app</li>
                <li>Sign in with your email: <strong>{email}</strong></li>
                <li>Your Native Brilliance report will be automatically loaded</li>
                <li>Explore your cognitive profile and personalized recommendations</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="completion-footer">
          <p className="support-text">
            Questions? Contact support at support@nativebrilliance.com
          </p>
        </div>
      </div>
    </div>
  );
}